import React, { Component, Fragment } from "react";
import { Redirect, withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import DeleteItem from "./DeleteItem";
// utils
import {
  AppBar,
  Grid,
  Icon,
  Paper,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@material-ui/core";
import "./index.css";
import { submit } from "redux-form";
import { isEqual } from "lodash";
import {
  initialValues,
  translateValues,
  initialArray,
  initialView,
  initialUserValues,
  translateLocation,
  translateUserValues
} from "./utils";
import { connect } from "react-redux";
import LogOutButton from "../Helpers/LogOutButton";
import Logo from "../Helpers/Logo";
import Properties from "./Properties";
import Users from "./Users";
import PropertiesEditForm from "./../User/Shared/Edit/PropertiesEditor/PropertiesEditForm";
import UserEditForm from "./../User/Shared/Edit/UserEditor/UserEditForm";

import LoadingContent from "./../Helpers/LoadingContent";
import {
  propertyGetProperties,
  propertyGetSelectedProperty,
  propertyUpdateProperty,
  usersGetUsers,
  propertyChangeField,
  usersChangeField,
  usersGetSelectedUser,
  propertyDeleteProperty,
  saveFile,
  usersUpdateUser,
  usersDeleteUser,
  usersSendFile,
  propertySendFile
} from "./../../actions";
import { validatePropertiesEditor } from "./../../actions/validation";

import { propertySelectors } from "./../../reducers/property";
import { usersSelectors } from "./../../reducers/users";
import Header from "../Header";
const modalContentData = {
  addProperty: "addProperty",
  deleteProperty: "deleteProperty",
  editProperty: "editProperty",
  addUser: "addUser",
  editUser: "editUser",
  deleteUser: "deleteUser"
};
class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActiveTab: 0,
      modalContent: null,
      isModalOpen: false,
      // validity: undefined,
      pageNumber: 1
    };
  }
  componentDidUpdate(prevProps) {
    const { selectedProperty } = this.props;
  }
  handlePageChange = pageNumber => {
    const { isActiveTab } = this.state;
    if (isActiveTab == 0) {
      this.props.dispatch(propertyGetProperties(pageNumber));
    } else {
      this.props.dispatch(usersGetUsers(pageNumber));
    }
  };
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(propertyGetProperties());
    dispatch(usersGetUsers());
  }
  handleShowModal = (value, modalContent = null) => {
    this.setState({
      isModalOpen: value,
      modalContent: modalContent
    });
    if (!value) {
      this.props.dispatch(propertyGetSelectedProperty(null));
      this.props.dispatch(usersGetSelectedUser(null));
    }
  };
  handleChangeTab = (event, isActiveTab) => {
    this.setState({
      isActiveTab
    });
  };
  //
  // ---------------------user---------------------
  handleSelectUser = user => {
    const { selectedUser, dispatch } = this.props;
    if (selectedUser && user.id == selectedUser.id) {
      return dispatch(usersGetSelectedUser(null));
    }
    return dispatch(usersGetSelectedUser(user));
  };
  handleEditUser = user => {
    this.handleSelectUser(user);
    this.handleShowModal(true, modalContentData.editUser);
  };
  handleConfirmDeleteUser = user => {
    this.handleSelectUser(user);
    this.handleShowModal(true, modalContentData.deleteUser);
  };
  handleUpdateUser(values, dispatch, props, selectedUser) {
    const translatedValues = translateUserValues(values, selectedUser);
    Object.keys(translatedValues).forEach(key => {
      if (isEqual(translatedValues[key], selectedUser[key])) {
        delete translatedValues[key];
      }
    });
    console.log("NEW VALUES >>", translatedValues); // DEBUG
    this.props
      .dispatch(usersUpdateUser(selectedUser.id, translatedValues))
      .then(res => {
        if (res.payload.data) {
          this.handleShowModal(false);
          dispatch(usersGetUsers());
        }
      });
  }
  handleDeleteUser = user => {
    const { dispatch } = this.props;
    this.handleShowModal(false);
    dispatch(usersDeleteUser(user.id)).then(res => {
      if (res.payload.data) {
        dispatch(usersGetUsers());
      }
    });
  };
  // ---------------------property---------------------
  handleUpdateProperty = values => {
    const { selectedProperty, landlord, dispatch } = this.props;
    const translatedValues = translateValues(
      values,
      selectedProperty,
      !landlord
    );
    // General equality checks
    Object.keys(translatedValues).forEach(key => {
      if (isEqual(translatedValues[key], selectedProperty[key])) {
        delete translatedValues[key];
      }
    });
    // Specific equality checks
    if (translatedValues.gender) {
      if (
        isEqual(
          translatedValues.gender,
          initialArray(selectedProperty, "gender").gender
        )
      )
        delete translatedValues.gender;
    }
    if (translatedValues.floor) {
      if (
        isEqual(
          translatedValues.floor,
          initialArray(selectedProperty, "floor").floor
        )
      )
        delete translatedValues.floor;
    }
    if (translatedValues.view) {
      if (
        isEqual(translatedValues.view, initialView(selectedProperty.view).view)
      )
        delete translatedValues.view;
    }
    if (translatedValues.location) {
      if (
        isEqual(
          translatedValues.location,
          translateLocation(selectedProperty.location).location
        )
      )
        delete translatedValues.location;
    }

    if (landlord) {
      if (translatedValues.rentMin || translatedValues.rentMin === 0)
        translatedValues.rentMax = translatedValues.rentMin;
      if (translatedValues.sizeMin || translatedValues.sizeMin === 0)
        translatedValues.sizeMax = translatedValues.sizeMin;
    }
    dispatch(
      propertyUpdateProperty(selectedProperty.id, translatedValues)
    ).then(res => {
      if (res.payload.data) {
        this.handleShowModal(false);
        dispatch(propertyGetProperties());
      }
    });
  };
  handleConfirmDeleteProperty = property => {
    this.props.dispatch(propertyGetSelectedProperty(property));
    this.handleShowModal(true, modalContentData.deleteProperty);
  };
  handleDeleteProperty = property => {
    const { dispatch } = this.props;
    this.handleShowModal(false);
    dispatch(propertyDeleteProperty(property.id)).then(res => {
      if (res.payload.data) {
        dispatch(propertyGetProperties());
      }
    });
  };
  handleEditProperty = property => {
    this.props.dispatch(propertyGetSelectedProperty(property));
    this.handleShowModal(true, modalContentData.editProperty);
  };

  // handleChangeFile = e => {
  //   const attachment = e.target.files[0];
  //   let formData = new FormData();
  //   formData.append("file", attachment);
  //   this.props.dispatch(saveFile(formData));
  // };
  handleChangeFile = (e, item, type) => {
    const { dispatch } = this.props;
    const file = e.target.files[0];
    let formData = new FormData();
    formData.append("file", file);
    switch (type) {
      case "property":
        return dispatch(propertySendFile(item.id, formData));
        return;
      case "user":
        return dispatch(usersSendFile(item.id, formData));
      default:
        return null;
    }
  };
  renderContent = () => {
    const { properties, users, selectedUser } = this.props;
    const { isActiveTab, propId } = this.state;
    switch (isActiveTab) {
      case 0:
        return (
          <>
            <div
              className="tool"
              onClick={() =>
                this.handleShowModal(true, modalContentData.addProperty)
              }
            >
              Add new property
            </div>
            <Properties
              properties={properties}
              handleEditProperty={this.handleEditProperty}
              handleDeleteProperty={this.handleConfirmDeleteProperty}
              handleChangeFile={this.handleChangeFile}
            />
          </>
        );
      case 1:
        return (
          <>
            <div
              className="tool"
              onClick={() =>
                this.handleShowModal(true, modalContentData.addProperty)
              }
            >
              Add new user
            </div>
            <Users
              selectedUser={selectedUser}
              users={users}
              handleSelectUser={this.handleSelectUser}
              handleEditUser={this.handleEditUser}
              handleDeleteUser={this.handleConfirmDeleteUser}
              handleChangeFile={this.handleChangeFile}
            />
          </>
        );
      default:
        return <Properties properties={properties} />;
    }
  };
  renderModalContent = () => {
    const { selectedProperty, selectedUser } = this.props;
    const { modalContent } = this.state;
    switch (modalContent) {
      case modalContentData.editProperty:
        if (selectedProperty) {
          return (
            <>
              <PropertiesEditForm
                form="propertiesEdit"
                onSubmit={this.handleUpdateProperty}
                onChange={this.handlePropertyChange}
                landlord={true}
                initialValues={initialValues(selectedProperty)}
              />
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={() => {
                  this.props.dispatch(submit("propertiesEdit"));
                }}
              >
                Submit
              </Button>
            </>
          );
        }
      case modalContentData.deleteProperty:
        return (
          <DeleteItem
            name="property"
            selectedItem={selectedProperty}
            handleDelete={this.handleDeleteProperty}
            handleShowModal={this.handleShowModal}
          />
        );
      case modalContentData.addProperty:
        return (
          <div>
            {" "}
            <input type="file" />{" "}
          </div>
        );
      case modalContentData.addUser:
        return (
          <div>
            <input type="file" />
          </div>
        );
      case modalContentData.editUser:
        return (
          <>
            <UserEditForm
              initialValues={initialUserValues(selectedUser)}
              onSubmit={(values, dispatch, props) =>
                this.handleUpdateUser(values, dispatch, props, selectedUser)
              }
              form="userEdit"
            />
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => {
                this.props.dispatch(submit("userEdit"));
              }}
            >
              Submit
            </Button>
          </>
        );
      case modalContentData.deleteUser:
        return (
          <DeleteItem
            name="user"
            selectedItem={selectedUser}
            handleDelete={this.handleDeleteUser}
            handleShowModal={this.handleShowModal}
          />
        );
      default:
        return null;
    }
  };
  render() {
    const {
      selectedProperty,
      propertiesCount,
      usersCount,
      propertyPageNumber,
      userPageNumber,
      propertyLoading,
      usersLoading,
      admin,
    } = this.props;
    let isLoading = propertyLoading || usersLoading;
    const { isActiveTab, isModalOpen, pageNumber } = this.state;

    if (!admin)
        return (<Redirect to="/"/>)

    return (
      <Fragment>
        <Header admin={true} loggedIn={true}/>
        <div className="admin">
          <h1 className="title ">Managing system</h1>
          <div className="menu">
            <Tabs
              centered
              value={isActiveTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.handleChangeTab}
              aria-label="disabled tabs example"
            >
              <Tab label="property" />
              <Tab label="user" />
            </Tabs>
          </div>
          {isLoading ? (
            <LoadingContent />
          ) : (
            <div className="content">{this.renderContent()}</div>
          )}
          <div>
            <Pagination
              activePage={
                isActiveTab == 0 ? propertyPageNumber : userPageNumber
              }
              itemsCountPerPage={10}
              totalItemsCount={isActiveTab == 0 ? propertiesCount : usersCount}
              pageRangeDisplayed={3}
              onChange={this.handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
        <Dialog
          open={this.state.isModalOpen}
          disableBackdropClick={false}
          onBackdropClick={() => this.handleShowModal(false)}
          onEscapeKeyDown={() => this.handleShowModal(false)}
        >
          <DialogTitle>Actions</DialogTitle>
          <DialogContent>
            <Grid container direction="column" alignItems="stretch">
              {this.renderModalContent()}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              onClick={() => this.handleShowModal(false)}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}
const mapStateToProps = state => ({
  properties: propertySelectors.getProperties(state.propertyReducer),
  propertiesCount: propertySelectors.getEntriesCount(state.propertyReducer),
  propertyPageNumber: propertySelectors.getPageNumber(state.propertyReducer),
  selectedProperty: propertySelectors.getSelectedProperties(
    state.propertyReducer
  ),
  propertyLoading: propertySelectors.getLoading(state.propertyReducer),
  selectedUser: usersSelectors.getSelectedUser(state.usersReducer),
  users: usersSelectors.getUsers(state.usersReducer),
  userPageNumber: usersSelectors.getPageNumber(state.usersReducer),
  usersCount: usersSelectors.getEntriesCount(state.usersReducer),
  usersLoading: usersSelectors.getLoading(state.usersReducer),
  bearer: state.user.bearerToken,
  landlord: state.user.data.isLandlord,
  admin: state.user.data.isAdmin,
});
export default withRouter(connect(mapStateToProps)(Admin));
